module.exports = __webpack_public_path__ + "img/Data Pending.ead206ae.svg";